import React from "react";

// Import images
import m1 from "../../../../../Assets/Images/defaultMedia1.jpeg";

export default function Links() {
  return (
    <section>
      {/* Today Section */}
      <div>
        <label className="text-sm">Today</label>
        <div className="flex gap-3 mt-2">
          <div className="flex items-start gap-3 bg-[#F0F0F3] rounded-xl p-2 w-full max-w-md">
            <img src={m1} alt="media" className="min-w-[64px] min-h-[64px] max-w-[64px] max-h-[64px] rounded-lg object-cover" />
            <div>
            <h3 className="font-semibold text-sm w-2/3 truncate">
            Over 160 FREE Tab Bar Component Variations             </h3>
              <p className="text-xs text-gray-500 mt-1">
                Lorem ipsum dolor sit amet consectetur. Sit lectus mauris
                volutpat ut viverra dignissim.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Yesterday Section */}
      <div className="my-3">
        <label className="text-sm">Yesterday</label>
        <div className="flex gap-3 mt-2">
          <div className="flex items-start gap-3 bg-[#F0F0F3] rounded-xl p-2 w-full max-w-md">
            <img src={m1} alt="media" className="min-w-[64px] min-h-[64px] max-w-[64px] max-h-[64px] rounded-lg object-cover" />
            <div>
            <h3 className="font-semibold text-sm w-2/3 truncate">
            Over 160 FREE Tab Bar Component Variations              </h3>
              <p className="text-xs text-gray-500 mt-1">
                Lorem ipsum dolor sit amet consectetur. Sit lectus mauris
                volutpat ut viverra dignissim.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="my-3">
        <label className="text-sm">Last Month</label>
        <div className="flex gap-3 mt-2">
          <div className="flex items-start gap-3 bg-[#F0F0F3] rounded-xl p-2 w-full max-w-md">
            <img src={m1} alt="media" className="min-w-[64px] min-h-[64px] max-w-[64px] max-h-[64px] rounded-lg object-cover" />
            <div>
            <h3 className="font-semibold text-sm w-2/3 truncate">
            Over 160 FREE Tab Bar Component Variations              </h3>
              <p className="text-xs text-gray-500 mt-1">
                Lorem ipsum dolor sit amet consectetur. Sit lectus mauris
                volutpat ut viverra dignissim.
              </p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
